import React from "react";
import about_us_1 from "../../../Assets/Images/about/about_us_1.png";
import AboutHeadings from "./AboutHeadings";

const AboutNGO = () => {
  const content = [
    // "AAFSA is a not for profit, non-political and social development organization established in 2022 dedicating to enhance the quality of lives of rural and urban poor in INDIA. The strategic priorities are mitigating acute poverty and starvation, ensuring social inclusion and justice, good governance and citizen’s right. Sensitizing communities identify and initiate development measures. Being a strong believer of the thought people’s participation key to social reforms, we facilitate community to be engaging with different initiatives taken for their development.",
    "We are directly working with the community and take their issues into larger development forums for accelerated growth. Besides the basic needs i.e. livelihood, health, education, habitation, emergency support, water and sanitation, we are analysing socio-economic issues, which prevent their growth. To make the success of NDLM mission, AaFSA is trying to create at least a digitally literate and empowered person per household in each block of INDIA.",
    "Our digital education to community is a remarkable contribution to the society. Our campaigns on making alive verbal tribal languages, saving indigenous seeds that are in endangered stage, street dogs and cattle care movement are exceptional efforts to serve the society differently. Support to visually impaired students, promotion of quality and inclusive education, enhancing the skills of youth, and financial support to poor genius students gives us incomparable pleasure, energizing us to continue our work even with minimum resources available. At present, we are focused on Odisha State and have a vision to reach PAN India in the next 5 years.",
  ];

  return (
    <div className="py-4 my-8 px-4 md:px-[5rem]">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        {/* Image */}
        <div
          className="col-span-1 flex h-full w-full items-center justify-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <img
            src={about_us_1}
            alt="About NGO"
            className="rounded-lg  lg:max-h-[34rem] h-auto  transform transition-transform duration-700 hover:scale-101"
          />
        </div>

        {/* Content */}
        <div className="col-span-1 flex flex-col">
          <AboutHeadings
            subtitle="About us"
            title="Who we are ?"
            textAlign="left"
          />

          <div className="mt-4 space-y-3">
            {content.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm md:text-base leading-relaxed text-[#555] text-justify tracking-wide"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay={400 + index * 200}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutNGO;

// import React from "react";
// import about_us_1 from "../../../Assets/Images/about/about_us_1.png";
// import AboutHeadings from "./AboutHeadings";

// const AboutNGO = () => {
//   const content = [
//     // "AAFSA is a not for profit, non-political and social development organization established in 2022 dedicating to enhance the quality of lives of rural and urban poor in INDIA. The strategic priorities are mitigating acute poverty and starvation, ensuring social inclusion and justice, good governance and citizen’s right. Sensitizing communities identify and initiate development measures. Being a strong believer of the thought people’s participation key to social reforms, we facilitate community to be engaging with different initiatives taken for their development.",
//     "We are directly working with the community and take their issues into larger development forums for accelerated growth. Besides the basic needs i.e. livelihood, health, education, habitation, emergency support, water and sanitation, we are analysing socio-economic issues, which prevent their growth. To make the success of NDLM mission, AaFSA is trying to create at least a digitally literate and empowered person per household in each block of INDIA.",
//     "Our digital education to community is a remarkable contribution to the society. Our campaigns on making alive verbal tribal languages, saving indigenous seeds that are in endangered stage, street dogs and cattle care movement are exceptional efforts to serve the society differently. Support to visually impaired students, promotion of quality and inclusive education, enhancing the skills of youth, and financial support to poor genius students gives us incomparable pleasure, energizing us to continue our work even with minimum resources available. At present, we are focused on Odisha State and have a vision to reach PAN India in the next 5 years.",
//   ];

//   return (
//     <div className="py-4 mt-8 px-4 md:px-[5rem]">
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Image */}
//         <div className="col-span-1" data-aos="fade-up" data-aos-duration="1000">
//           <img
//             src={about_us_1}
//             alt="About NGO"
//             className="rounded-lg w-full transform transition-transform duration-700 hover:scale-105"
//           />
//         </div>

//         {/* Content */}
//         <div className="col-span-1">
//           <AboutHeadings
//             subtitle="About us"
//             title="Who we are ?"
//             textAlign="left"
//           />

//           <div className="mt-4 space-y-4">
//             {content.map((paragraph, index) => (
//               <p
//                 key={index}
//                 className="text-sm md:text-base leading-relaxed text-[#555] text-justify tracking-wide"
//                 data-aos="fade-up"
//                 data-aos-duration="1000"
//                 data-aos-delay={400 + index * 200} // staggered delays
//               >
//                 {paragraph}
//               </p>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutNGO;
